
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'ngx-localstorage';
import { over } from "stompjs";
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { EvrotrustGeneralComponent } from '../components/evrotrust/evrotrust-general/evrotrust-general.component';
import { DownloadEvrotrustModalComponent } from '../components/evrotrust/download-evrotrust-modal/download-evrotrust-modal.component';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  token;
  language;
  headers
  url=environment.SOCKET_URL
  socketClient;
  wssubscription: Subscription
  receivedMessages;
  policyRefN;
  threadId;
  chatMessage;
  nationalId;
  msg;
  
  constructor(private http: HttpClient, private storage: LocalStorageService, private dialogService: NxDialogService) { }

  // connect(){
  //   const data = this.storage.get('data');
  //   this.policyRefN = data.sPlcNomer;
  //   this.nationalId = data.policyholderData.egn;

  //   this.headers = {
  //     "policyID": this.policyRefN
  //    };

  //   let ws =  new WebSocket(this.url);
  //   this.socketClient = over(ws);
  //   this.socketClient.connect(this.headers, (frame) => {
  //     this.getSubscription()          
  //   },
  //     this.errorCallBack
  //   );
  // }


  // errorCallBack(error) {
  //   console.log("Connexion failure" + error);
  // }

  // setThreadId(thread){
  //   this.threadId = thread
  // }

  // getSubscription() {
  //   this.wssubscription =  this.socketClient.subscribe('/api/check-documents-status',
  //     (message) => {
  //       this.receivedMessages = message.body;
  //       return this.receivedMessages;
  //     }, this.headers);

  //    let message = {
  //       egn: this.nationalId,
  //       policyNum: this.policyRefN
  //     }

  //     this.sentMessages(message);
  // }

  // getDocStatus(){
  //   this.socketClient.send("/message", this.headers, JSON.stringify(this.getMessage()));
  // }

  // sentMessages(status?){
  //   if(status){
  //     this.msg = {
  //       egn: this.nationalId,
  //       policyNum: this.policyRefN,
  //       threadId : this.threadId,
  //       filesUploadedBPM: true
  //     }
  //   }

  //   this.socketClient.send("/message", this.headers, JSON.stringify(this.msg));
  // }

  disconnect(){
    if(this.socketClient.connected ===true){
    this.wssubscription.unsubscribe();
    this.socketClient.disconnect();
    }
  }

  unsuccessfulCunnection(){
    this.dialogService.closeAll();

    this.dialogService.open(DownloadEvrotrustModalComponent, {
      data: {
        subheading: 'evrotrust.unsuccessfulConnection'
       },
      showCloseIcon: true,
    });
  }


  Error(){
    this.dialogService.closeAll();

    this.dialogService.open(DownloadEvrotrustModalComponent, {
      data: {
        subheading: 'evrotrust.error'
       },
      showCloseIcon: true,
    });

  }

  didNotAgreed(){
    this.dialogService.closeAll();

    this.dialogService.open(DownloadEvrotrustModalComponent, {
      data: {
        subheading: 'evrotrust.rejected'
       },
      showCloseIcon: true,
    });

  }
}
